import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  companyId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  orderId: Types.Scalars['String']['input'];
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly campaignMediaplanStats: ReadonlyArray<{ readonly __typename?: 'YalperCampaignMediaplanStat', readonly campaignId: string, readonly campaignName: string, readonly accountName: string }>, readonly marvinFullAiReport?: { readonly __typename?: 'MarvinDetailedAiReport', readonly marvinOrderId?: string | null, readonly campaignIds?: ReadonlyArray<string | null> | null, readonly goals?: ReadonlyArray<{ readonly __typename?: 'AiReportGoal', readonly id: number, readonly name: string, readonly counterId: number, readonly counterName: string } | null> | null, readonly reportJson?: { readonly __typename?: 'AiReportResponse', readonly projectInfo?: { readonly __typename?: 'ProjectInfo', readonly atribModel?: string | null, readonly buildDate?: string | null, readonly clientName?: string | null, readonly dateFrom?: string | null, readonly dateTo?: string | null, readonly name?: string | null, readonly currentMetrics?: { readonly __typename?: 'CurrentMetrics', readonly actualBudget?: number | null, readonly actualKpi?: number | null, readonly avgCpl?: number | null } | null, readonly goals?: { readonly __typename?: 'ProjectGoals', readonly kpiName?: string | null, readonly kpiUnits?: string | null, readonly targetBudget?: number | null, readonly targetKpi?: number | null } | null } | null, readonly recommendationGroups?: ReadonlyArray<{ readonly __typename?: 'RecommendationGroup', readonly entityType?: string | null, readonly totalBudgetImpact?: number | null, readonly totalKpiImpact?: number | null, readonly recommendations?: ReadonlyArray<{ readonly __typename?: 'Recommendation', readonly actionType?: string | null, readonly actionUnits?: string | null, readonly actionValue?: number | null, readonly campaignId?: string | null, readonly campaignName?: string | null, readonly checkCampaigns?: ReadonlyArray<string | null> | null, readonly description?: string | null, readonly device?: string | null, readonly disabled?: boolean | null, readonly entityId?: string | null, readonly entityType?: string | null, readonly essence?: string | null, readonly hypothesisDigital?: string | null, readonly hypothesisTheory?: string | null, readonly id?: number | null, readonly location?: string | null, readonly netType?: string | null, readonly notes?: string | null, readonly os?: string | null, readonly placement?: string | null, readonly priority?: string | null, readonly segmentAge?: string | null, readonly segmentGender?: string | null, readonly groupId?: string | null, readonly groupName?: string | null, readonly keyword?: string | null, readonly keywordId?: string | null, readonly tunable?: boolean | null, readonly forecast?: { readonly __typename?: 'Forecast', readonly comment?: string | null, readonly impactBudgetValue?: number | null, readonly impactKpiUnits?: string | null, readonly impactKpiValue?: number | null } | null, readonly justification?: { readonly __typename?: 'Justification', readonly budget?: number | null, readonly comment?: string | null, readonly conversions?: number | null, readonly conversionsShare?: number | null, readonly ctr?: number | null, readonly kpi?: number | null, readonly kpiDelta?: number | null } | null } | null> | null } | null> | null, readonly summary?: { readonly __typename?: 'AiReportSummary', readonly expectedBudget?: number | null, readonly expectedKpi?: number | null, readonly expertResume?: string | null } | null } | null } | null } | null } | null };

export type GetCurrentUserCompanyNameQueryVariables = Types.Exact<{
  companyId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type GetCurrentUserCompanyNameQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly name: string, readonly uuid: string } | null } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($companyId: ID, $orderId: String!, $startDate: Date!, $endDate: Date!) {
  currentUser {
    company(id: $companyId) {
      campaignMediaplanStats(startDate: $startDate, endDate: $endDate) {
        campaignId
        campaignName
        accountName
      }
      marvinFullAiReport(orderId: $orderId) {
        marvinOrderId
        campaignIds
        goals {
          id
          name
          counterId
          counterName
        }
        reportJson {
          projectInfo {
            atribModel
            buildDate
            clientName
            dateFrom
            dateTo
            name
            currentMetrics {
              actualBudget
              actualKpi
              avgCpl
            }
            goals {
              kpiName
              kpiUnits
              targetBudget
              targetKpi
            }
          }
          recommendationGroups {
            entityType
            totalBudgetImpact
            totalKpiImpact
            recommendations {
              actionType
              actionUnits
              actionValue
              campaignId
              campaignName
              checkCampaigns
              description
              device
              disabled
              entityId
              entityType
              essence
              hypothesisDigital
              hypothesisTheory
              id
              location
              netType
              notes
              os
              placement
              priority
              segmentAge
              segmentGender
              groupId
              groupName
              keyword
              keywordId
              tunable
              forecast {
                comment
                impactBudgetValue
                impactKpiUnits
                impactKpiValue
              }
              justification {
                budget
                comment
                conversions
                conversionsShare
                ctr
                kpi
                kpiDelta
              }
            }
          }
          summary {
            expectedBudget
            expectedKpi
            expertResume
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      orderId: // value for 'orderId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;
export const GetCurrentUserCompanyNameDocument = gql`
    query GetCurrentUserCompanyName($companyId: ID) {
  currentUser {
    company(id: $companyId) {
      name
      uuid
    }
  }
}
    `;

/**
 * __useGetCurrentUserCompanyNameQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserCompanyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserCompanyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserCompanyNameQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCurrentUserCompanyNameQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserCompanyNameQueryPage, GetCurrentUserCompanyNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserCompanyNameQueryPage, GetCurrentUserCompanyNameQueryVariables>(GetCurrentUserCompanyNameDocument, options);
      }
export function useGetCurrentUserCompanyNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserCompanyNameQueryPage, GetCurrentUserCompanyNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserCompanyNameQueryPage, GetCurrentUserCompanyNameQueryVariables>(GetCurrentUserCompanyNameDocument, options);
        }
export function useGetCurrentUserCompanyNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserCompanyNameQueryPage, GetCurrentUserCompanyNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserCompanyNameQueryPage, GetCurrentUserCompanyNameQueryVariables>(GetCurrentUserCompanyNameDocument, options);
        }
export type GetCurrentUserCompanyNameQueryHookResult = ReturnType<typeof useGetCurrentUserCompanyNameQuery>;
export type GetCurrentUserCompanyNameLazyQueryHookResult = ReturnType<typeof useGetCurrentUserCompanyNameLazyQuery>;
export type GetCurrentUserCompanyNameSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserCompanyNameSuspenseQuery>;
export type GetCurrentUserCompanyNameQueryResult = Apollo.QueryResult<GetCurrentUserCompanyNameQueryPage, GetCurrentUserCompanyNameQueryVariables>;